var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Rider Directory',"subtitle":'Edit Rider Profile'}}),(_vm.rider.id)?_c('rider-form',{attrs:{"action":'edit',"rider":_vm.rider}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }